"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFRESH_BEFORE_EXPIRATION_SECONDS = exports.EVENTS = exports.PREFERRED_SIGNING_ALG = exports.SOLID_CLIENT_AUTHN_KEY_PREFIX = void 0;
exports.SOLID_CLIENT_AUTHN_KEY_PREFIX = "solidClientAuthn:";
exports.PREFERRED_SIGNING_ALG = ["ES256", "RS256"];
exports.EVENTS = {
    NEW_REFRESH_TOKEN: "newRefreshToken",
    ERROR: "onError",
    SESSION_EXPIRED: "sessionExpired",
    SESSION_EXTENDED: "sessionExtended",
    TIMEOUT_SET: "timeoutSet",
};
exports.REFRESH_BEFORE_EXPIRATION_SECONDS = 5;
//# sourceMappingURL=constant.js.map